import { MovieOpenPlayIcon } from './MovieOpenPlayIcon';

/**
 * author: Colton Wiscombe
 * id F3CB37FD-2C97-4CD1-83C0-18677B81DAC6
 * name movie-open-play
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-play.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOpenPlayIcon = MovieOpenPlayIcon;
export default ClapperboardOpenPlayIcon